import { render } from "./EventsPage.vue?vue&type=template&id=4d692791&scoped=true"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"

import "./EventsPage.vue?vue&type=style&index=0&id=4d692791&lang=scss"
import "./EventsPage.vue?vue&type=style&index=1&id=4d692791&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d692791"]])

export default __exports__